import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { withStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import * as DeviceActionCreators from '../../../actions/device'

class Egauge extends React.Component {
  static propTypes = {
    device: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired,
  }

  static mapDispatchToProps(dispatch) {
    return {
      deviceActions: bindActionCreators(DeviceActionCreators, dispatch),
    }
  }

  static styles = {}

  onRestart = () => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'restart')
  }

  onSetConfig = () => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'setConfig')
  }

  render() {
    return (
      <>
        <Button onClick={this.onRestart}>Restart</Button>
        <Button onClick={this.onSetConfig}>Set Config</Button>
      </>
    )
  }
}

export default connect(
  Egauge.mapStateToProps,
  Egauge.mapDispatchToProps,
)(withStyles(Egauge.styles)(Egauge))
